module.exports = __webpack_public_path__ + "img/23.69da87b5.png";